export const environment = {
    sentryEnvironment: 'development',
    production: false,
    kenallApiKey: '88db2db8d0de548acf64fca1bdae9356a5c519fd',
    api: 'https://dev-api.questionnaire.musubi.app',
    region: 'ap-northeast-1',
    IdentityPoolId: 'ap-northeast-1:45b85a7b-1709-4261-97e7-8e0edd50f39a',
    launchDarklyClientId: '5e9eaf30d5f76309e3eb8612',
};
